import { integrationMiddleware } from "../network/middlewareHttp";
import { AxiosInstance } from "axios";
import { baseURL } from "./FetchUrl";

class CategoriesCatalog{
    apiURL = baseURL
    getEndpoint = '/api/Categories/get'
    postEndpoint = '/api/Categories/post'
    putEndpoint = '/api/Categories/put'
    deleteEndpoint = '/api/Categories/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')

    getCategoriesList = async(filter) => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint + "?filter=" + (filter ? "true" : "false"))
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postCategori = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteCategorie = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateCategorie = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default CategoriesCatalog
